import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // "&.vo-global__content-with-toolbar": {
      //   padding: 0,
      // },
      // border: "1px solid red",
      marginTop: theme.spacing(4),
    },
    paper: {
      // background: "none",
      // boxShadow: "none",
    },
    toolbar: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[10],
      marginBottom: theme.spacing(2),
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      position: "sticky",
      top: theme.spacing(9),
      zIndex: 5,
    },
    content: {
      // boxSizing: "border-box",
      // fontSize: theme.typography.body1.fontSize,
    },
    previewWrapper: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      // marginLeft: "auto",
      // marginRight: "auto",
      // maxWidth: 700,
    },
    grow: {
      flex: 1,
    },
    // previewPaperWrapper: {
    //   backgroundColor: theme.palette.background.paper,
    //   borderRadius: theme.shape.borderRadius,
    //   boxShadow: theme.shadows[10],

    //   // height: "100%",
    //   // width: "70%",

    //   // flex: 1,
    //   // boxSizing: "content-box",
    //   // flex: 1,
    //   // paddingRight: "38%",
    //   // width: 0,

    //   // .outer {
    //   //   position: relative;
    //   //   &:before {
    //   //     display: block;
    //   //     content: "";
    //   //     width: 100%;
    //   //     padding-top: (99 / 70) * 100%;
    //   //   }
    //   //   > .inner {
    //   //     position: absolute;
    //   //     top: 0;
    //   //     right: 0;
    //   //     bottom: 0;
    //   //     left: 0;
    //   //   }
    //   // }

    //   marginLeft: "auto",
    //   marginRight: "auto",
    //   maxWidth: 400,
    //   position: "sticky",
    //   top: 98,
    //   [theme.breakpoints.up("lg")]: {
    //     maxWidth: 500,
    //   },
    //   [theme.breakpoints.up("xl")]: {
    //     maxWidth: 600,
    //   },
    //   "&:before": {
    //     display: "block",
    //     content: "''",
    //     width: "100%",
    //     paddingTop: "calc(99 / 70 * 100%)",
    //   },
    // },
    // previewPaper: {
    //   bottom: 0,
    //   display: "flex",
    //   left: 0,
    //   position: "absolute",
    //   right: 0,
    //   top: 0,

    //   // height: "297mm",
    //   // height: "calc(29.7vw)",
    //   // width: "calc(21vw)",
    //   // width: "210mm",
    // },
    form: {
      padding: theme.spacing(2),
    },
    row: {
      marginBottom: theme.spacing(2),
      "&:last-child": {
        marginBottom: 0,
      },
    },
  })
);
